import { fullSituationMatrimonialeOptions } from '@lib/models/situation-matrimoniale.model';
import { ReferenceDataService } from '@lib/services/reference-data.service';
import { of } from 'rxjs';
import { booleanOptions, eqOperator, fullComparator, inOperator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getRelationsBuilders(referenceDataService: ReferenceDataService): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'ETAT_CIVIL_AVANTAGE_MATRIMONIAL',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.etatCivil.typeAvantageMatrimonialCode',
      inOperator,
      'SelectMultiple',
      referenceDataService.getTypeAvantageMatrimoniaux()
    ),
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'DISPOSITION_DONATION_PROCHES',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.disposition.autresDispositions',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'DISPOSITION_DONATION_DERNIER_VIVANT',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.donationDernierVivant',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'ETAT_CIVIL_ENFANTS_CHARGE',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.etatCivil.nombreEnfantACharge',
      fullComparator,
      'InputNumeric',
      undefined,
      2
    ),
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'ETAT_CIVIL_REGIME_MATRIMONIAL',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.etatCivil.typeRegimeSituationEtatCivilCode',
      inOperator,
      'SelectMultiple',
      of(referenceDataService.typeRegimeMatrimonialMariageOptions)
    ),
    new ItemFiltreCustomBuilder(
      'RELATIONS',
      'ETAT_CIVIL_SITUATION_MATRIMONIALE',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.etatCivil.typeSituationEtatCivilCode',
      inOperator,
      'SelectMultiple',
      of(fullSituationMatrimonialeOptions)
    ),
  ];
}
